import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MetaDefinition } from '@angular/platform-browser';
import { CompDetailService } from '@b2b/core/api/detail/detail.service';
import { ImageOptimizerService } from '@sparro/app/core/helpers/image-optimizer';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';
import { UNI_CONSTANTS } from '@sparro/app/core/config/constants.config';

@Component({
  selector: 'app-dynamic-pricing',
  templateUrl: './dynamic-pricing.component.html',
  styleUrls: ['./dynamic-pricing.component.scss']
})

export class DynamicPricingComponent implements OnInit {
  compSlug: string;
  modules = [];
  percentage: number;
  pricingSlug: string;
  isLoading: boolean = false;
  isLoadingNext: boolean = false;
  dynamicCount: number = 0;
  next: string;
  registrationLeft: number;
  defaultImage: string = UNI_CONSTANTS.NO_IMAGE.COMP_OR_PROJECT;

  @ViewChild('tooltip') tooltip: ElementRef;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public metaService: MetaService,
    private about: CompDetailService,
    private renderer: Renderer2,
    public imageOptimizer: ImageOptimizerService
  ) {
  }

  ngOnInit(): void {
    this.pricingSlug = this.route.snapshot.params.pricing_slug;
    this.compSlug = this.route.parent.snapshot.params.comp_slug;
    this.getDynamicCount();
    this.getModule();
  }

  getDynamicCount(): void {
    this.dynamicCount = this.about.getDynamicCount();
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    this.setElementStyle();
  }

  tooltipHoverEvent(event?: boolean): void {
    this.renderer.setStyle(this.tooltip.nativeElement, 'visibility', event ? 'visible' : 'hidden');
  }


  getModule(): void {
    this.isLoading = true;
    this.about.pricingModule(this.compSlug, this.pricingSlug).subscribe(
      (response: any) => {
        this.modules = response.results;
        this.next = response.next;
        this.percentage = ((this.dynamicCount - this.modules[0].min_count + 1) /
          (this.modules[0].max_count - this.modules[0].min_count)) * 100;
        if (this.percentage === 0) {
          this.percentage = 10;
        }
        if (this.percentage > 100 && this.modules.length === 1) {
          this.percentage = 100;
        }
        this.setElementStyle();
        this.registrationLeft = (this.modules[0].max_count - this.modules[0].min_count) - (this.dynamicCount - this.modules[0].min_count);
        this.updateMetaInfo();
        this.isLoading = false;
        }, (error) => {
          console.log(error);
          this.isLoading = false;
        }
    );
  }

  updateMetaInfo(): void {
    this.about.fetchCompetition(this.compSlug, (competition: any) => {
      let metaInfo: MetaDefinition[] = [];
      const awardArray = [];
      if (this.modules.length && this.modules[0]?.prizes.length) {
        this.modules[0]?.prizes.forEach(prize => {
          awardArray.push(`${prize.name} ${prize.subtitle}`);
        });
      }
      const title = `${competition.title} ${competition.disciplines[0]?.name} Competition | ${competition.location?.name ?
        competition.location.name : competition.location?.country?.name} | Awards & Fees`;

      const description = `${this.registrationLeft} registrations left in this round. ${awardArray.length ?
        `${awardArray.join('. ')}.` : ''}`;
      const image = competition.image ? this.renderImage(competition.image) : '';
      metaInfo = [
        { name: 'title', content: title },
        { name: 'description', content: description },
        { name: 'url', content: window.location.href },
        { name: 'image', content: image },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        { name: 'twitter:url', content: window.location.href },
        { name: 'twitter:image', content: image },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: window.location.href },
        { property: 'og:image', content: image },
        { property: 'og:image:alt', content: title },
        { property: 'og:type', content: 'website' }
      ];
      metaInfo.forEach(meta => {
        this.metaService.updateMetaInfo(meta);
      });
      this.metaService.updateMeta(metaInfo);
      this.metaService.updateTitle(title);
      this.metaService.createCanonicalURL();
    });
  }

  setElementStyle(): void {
    if (this.percentage) {
      const styleElem = document.head.appendChild(document.createElement('style'));
      styleElem.innerHTML = `.dynamic-timeline::after {height: ${this.percentage}% !important;}
	    .active-timeline-end-point::after { top: ${this.percentage}%; }`;
    } else {
      console.log('% not defined');
    }
  }

  loadNextDeadlines(): void {
    this.isLoadingNext = true;
    this.about.getNextPricingModule(this.next).subscribe(
      (response: any) => {
        // this.modules = [...this.modules, response.results];
        this.isLoadingNext = false;
        response.results.map((item) => {
          this.modules.push(item);
        });
        this.next = response.next;
    },
    (error: any) => {
      this.isLoadingNext = false;
    });
  }

  renderImage(image: string): string {
    return this.imageOptimizer.renderImage(image, window.innerWidth, '');
  }
}
